import React, { useEffect, useState } from "react";
import ProductSearchHeader from "../components/ProductComp/ProductSearchHeader";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { toggleOn } from "../assets/img";
import OverViewComp from "../components/DecorativeDetailComp/OverViewComp";
import VendorPricingComp from "../components/DecorativeDetailComp/VendorPricingComp";
import { useLocation, useNavigate } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import PricingComp from "../components/DecorativeComp/PricingComp";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {
  useDecorativeMethodeViewPostMutation,
  useLazyDecorativeMethodeViewQuery,
} from "../redux/api/api";

const DecorativeDetailScreen = () => {
  const [priceBook, setpriceBook] = useState(true);
  const [list, setList] = useState({});
  const [previousOrder, setPreviousOrder] = useState(false);
  const [tagged, setTagged] = useState(false);
  const [edit, setEdit] = useState(false);
  const [decorativeMethod, setDecorativeMethod] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(location?.state?.id);
  const id = location?.state?.id;
  const types = location?.state?.type;
  const data = location?.state?.data;
  // console.log(types);
  // {types === 'John Rolph' ?

  // console.log("location", location);

  //RTK
  // const [decorativeApi]=useLazyDecorativeMethodeViewQuery();
  const [decorativeApi] = useDecorativeMethodeViewPostMutation();

  const getdecorApi = () => {
    let formdata = new FormData();
    formdata.append("vendor_id", location?.state?.data?.id);
    decorativeApi({ payload: formdata, id: id?.id })
      .unwrap()
      .then((res) => {
        console.log(res);
        setList(res?.vendor_decor_price);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getdecorApi();
  }, []);

  return (
    <div className="dashRightView p-5 home_section trans">
      <ProductSearchHeader />
      <div className="w-100 top_head_cust py-3">
       
        <h5 class="f4 fs-sm-21 fs-md-22 fs-lg-23 fs-xl-24 fs-xxl-25 primary">
          {location?.state?.data?.legal_name}
        </h5>
        
      </div>
      <div className="d-flex mt-2 ac-jb flex-column flex-md-row w-100">
        <div className="d-flex mt-3 ac-jc align-items-center">
          <p
            className="f4 fs-sm-14 fs-md-15 fs-lg-16 fs-xl-17 fs-xxl-18 primary d-flex text-center"
            role={"button"}
            onClick={() => navigate(-1)}
          >
            <KeyboardBackspaceIcon />
          </p>
          <div
            onClick={() => {
              setpriceBook(true);
              setTagged(false);
              setPreviousOrder(false);
            }}
            style={{ cursor: "pointer" }}
            className={`${
              priceBook
                ? "border-bottom-1 border-top-0 border-start-0 border-end-0 border-primar"
                : ""
            } ms-4 text-center`}
          >
            <p
              className={`${
                priceBook ? "black" : "gray"
              } f3 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 text-center `}
            >
              Overview
            </p>
          </div>
          
        </div>
       
      </div>
      {priceBook && (
        <OverViewComp
         data={data}
          edit={edit}
          types={types}
          list={list}
          setDecorativeMethod={setDecorativeMethod}
          decorativeMethod={decorativeMethod}
        />
      )}
   
      <div className="d-flex as-js w-100  mt-5">
        <button
          class="cust-btn addbtn mt-sm-3 mx-3 mt-2 bg-primar text-white f3 fs-11 fs-lg-12 fs-xl-13 fs-xxl-14 px-5 rounded"
          onClick={() => {
            priceBook
              ? navigate(-1, { state: { form: "decorative", type: types } })
              : setpriceBook(true);
            setPreviousOrder(false);
          }}
        >
          Back
        </button>
       
      </div>
      <div className="w-100 mt-5">
        <p className="primary f2 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 mt-1 text-start">
          Last updated on August 28, 2023 at 03:10 AM{" "}
        </p>
      </div>
    </div>
  );
};

export default DecorativeDetailScreen;
